import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  HStack,
  Input,
  Spinner,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { api } from "../../api/compensatoryDatesAPI";
import moment from "moment";
export const CompensatoryDatesTable: React.FC = () => {
  const [dates, setDates] = useState<string[]>([]);
  const [newDate, setNewDate] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const toast = useToast();
  const [refreshIndex, setRefreshIndex] = useState(0);

  useEffect(() => {
    api.getAllCompensatoryDates()
      .then((res) => {
          console.log(res.data)
        setDates(res.data.compensatory_days);
      })
      .catch(() =>
        toast({
          title: "Error loading compensatory dates.",
          status: "error",
          duration: 3000,
          isClosable: true,
        })
      )
      .finally(() => setLoading(false));
  }, [refreshIndex]);

  const addDate = async () => {
    if (!newDate) return;
    try {
  await api.addCompensatoryDate(dayjs(newDate).format("DD-MM-YYYY"));
      setNewDate("");
      setRefreshIndex((prev) => prev + 1);
      toast({
        title: "Date added.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Error adding date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const deleteDate = async (id: string) => {
    try {
      await api.deleteCompensatoryDate(id);
      setRefreshIndex((prev) => prev + 1);
      toast({
        title: "Date deleted.",
        status: "info",
        duration: 2000,
        isClosable: true,
      });
    } catch {
      toast({
        title: "Failed to delete date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  if (loading) {
    return <Spinner size="lg" />;
  }

  return (
    <Box mt={5} borderWidth={1} borderRadius="md" p={3} shadow="sm" width={{base: "100%", md: "sm"}} maxW="100%" overflowX="auto" flexGrow={1}>
      <Heading size="sm" mb={3}>
        Compensatory Dates
      </Heading>
      <FormControl>
        <FormLabel>Add New Date</FormLabel>
        <HStack>
          <Input
            type="date"
            value={newDate}
            onChange={(e) => setNewDate(e.target.value)}
            placeholder="Date"
          />
          <Button colorScheme="teal" onClick={addDate}>
            Add
          </Button>
        </HStack>
      </FormControl>
      <Table mt={3} variant="striped" size="sm">
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
         {dates.map((dateObj) => (
          <Tr key={dateObj}>
            <Td>{moment(dateObj, "DD-MM-YYYY").format("DD-MM-YYYY")}</Td>
            <Td>
              <Button
                size="xs"
                colorScheme="red"
                onClick={() => deleteDate(dateObj)}
              >
                Delete
              </Button>
            </Td>
          </Tr>
        ))}
        </Tbody>
      </Table>
    </Box>
  );
};
